'use client';
import { DownOutlined } from '@ant-design/icons';
import { appEnvironment } from '@benzinga/utils';
import { DEUFlag, ESPFlag, FRAFlag, ITAFlag, JPNFlag, KORFlag, USAFlag } from '@benzinga/icons';
import { menus } from '../menu-data';
import styles from './GlobalMenu.module.scss';

const CountryCodes = {
  DEU: DEUFlag,
  ESP: ESPFlag,
  FRA: FRAFlag,
  ITA: ITAFlag,
  JPN: JPNFlag,
  KOR: KORFlag,
  USA: USAFlag,
};

export const GlobalMenu = () => {
  if (!appEnvironment().isApp()) {
    return null;
  }

  const USAIcon: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  > = USAFlag;

  return (
    <div className={`${styles.menuWrapper} global-menu menu-wrapper`}>
      <div aria-label="Global Menu" className="menu-button" role="button">
        <span className="global-text w-[25px] h-[16px]">
          <USAIcon title="USA" />
        </span>
        <DownOutlined />
      </div>
      <div className="global-menu-dropdown">
        {menus?.globalMenu[0]?.subnav?.links?.map((item, i: number) => {
          const CountryIcon: React.FunctionComponent<
            React.SVGProps<SVGSVGElement> & {
              title?: string | undefined;
            }
          > = CountryCodes[`${item.img_key}`];
          return (
            <div className="global-menu-item" key={i}>
              <a href={item.href} rel="noreferrer" tabIndex={0} target="_blank">
                <span className="w-[25px] h-[16px]">
                  <CountryIcon title={item.label} />
                </span>
                <span>{item.label}</span>
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
};
